import React from 'react';
import styled, { css } from 'styled-components';
import { Container } from '../../styles';
import EdgeLabelWrapper from '../components/EdgeLabelWrapper';

const text = {
  pastePreview: 'Hier wordt ingevoegd',
};

type Props = {
  midX: number;
  midY: number;
};

/**
 * The container that shows the selected paste container
 */
const PreviewEdgeLabel: React.FCC<Props> = ({ midX, midY }) => (
  <EdgeLabelWrapper midX={midX} midY={midY}>
    <Container $variant="preview" $interactive={false} disabled aria-disabled>
      <PreviewDot aria-hidden />
      {text.pastePreview}
    </Container>
  </EdgeLabelWrapper>
);

export default PreviewEdgeLabel;

const PreviewDot = styled.span(
  ({ theme }) => css`
    width: ${theme.space('xs')};
    height: ${theme.space('xs')};
    border-radius: ${theme.getTokens().border.radius.full};
    background-color: ${theme.color('white')};
  `,
);
